import{View}from'./View';/**
 * An abstract visual Calendar
 */export class Viz extends View{}